import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Strong global protection for email inputs:
// - block insertion from emoji panel (beforeinput)
// - sanitize paste
// - cleanup any residual punycode like "xn--..." on input
;(function () {
    const emojiRegex = /[\p{Extended_Pictographic}]/u;
    const allowedCharRegex = /^[0-9a-zA-ZÀ-ÿ@._+\-]$/u;
    const punycodeRegex = /xn--[0-9a-z-]+/gi;

    function isEmailInput(el) {
        return el && el.tagName === 'INPUT' && el.type === 'email';
    }

    function removeInvalidAndPuny(s) {
        if (!s) return '';
        try {
            return s.replace(/[\p{Extended_Pictographic}]/gu, '').replace(/[^0-9a-zA-ZÀ-ÿ@._+\-]/gu, '').replace(punycodeRegex, '');
        } catch (_) {
            let out = '';
            for (const ch of s) {
                const cp = ch.codePointAt(0);
                if (cp > 0xffff) continue;
                if (!allowedCharRegex.test(ch)) continue;
                out += ch;
            }
            return out.replace(punycodeRegex, '');
        }
    }

    function onBeforeInput(e) {
        const el = e.target;
        if (!isEmailInput(el)) return;
        const data = e.data;
        if (!data) return;
        for (let i = 0; i < data.length; i++) {
            const ch = data[i];
            if (emojiRegex.test(ch) || !allowedCharRegex.test(ch)) {
                e.preventDefault();
                return;
            }
        }
    }

    function onPaste(e) {
        const el = e.target;
        if (!isEmailInput(el)) return;
        const pasted = (e.clipboardData && e.clipboardData.getData('text')) || '';
        if (!pasted) return;
        const sanitized = removeInvalidAndPuny(pasted);
        if (sanitized === pasted) return; 
        e.preventDefault();
        const selStart = el.selectionStart || 0;
        const selEnd = el.selectionEnd || 0;
        const before = el.value.slice(0, selStart);
        const after = el.value.slice(selEnd);
        const newVal = before + sanitized + after;
        el.value = newVal;
        const newPos = (before + sanitized).length;
        try { el.setSelectionRange(newPos, newPos); } catch (_) {}
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function onInput(e) {
        const el = e.target;
        if (!isEmailInput(el)) return;
        const curr = el.value || '';
        const sanitized = removeInvalidAndPuny(curr);
        if (sanitized === curr) return;
        const selStart = el.selectionStart || 0;
        const before = curr.slice(0, selStart);
        const allowedBefore = removeInvalidAndPuny(before);
        try {
            el.value = sanitized;
            const newPos = allowedBefore.length;
            el.setSelectionRange(newPos, newPos);
        } catch (_) {
            el.value = sanitized;
        }
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }

    document.addEventListener('beforeinput', onBeforeInput, true);
    document.addEventListener('paste', onPaste, true);
    document.addEventListener('input', onInput, true);
})();
